// Placeholder insertion for the template editor (mobile overhaul Phase D
// §14.1 C). The chips insert at the caret of whichever field was last
// focused — on a phone the caret is the only thing the user has, so the
// maths is pulled out of the component and tested.

/** "{{client_name}}" whether the chip carries the braces or not. */
export function placeholderTag(raw: string): string {
  return raw.startsWith('{{') ? raw : `{{${raw}}}`;
}

/** Splice the tag in at `caret` (end of text when the caret is unknown) and
    report where the caret should land after it. */
export function insertPlaceholder(
  text: string,
  caret: number | null | undefined,
  raw: string,
): { text: string; caret: number } {
  const tag = placeholderTag(raw);
  const pos = caret === null || caret === undefined || !Number.isFinite(caret)
    ? text.length
    : Math.min(text.length, Math.max(0, Math.round(caret)));
  return { text: text.slice(0, pos) + tag + text.slice(pos), caret: pos + tag.length };
}
